import {TimelineLite} from "gsap";
import {RoadKill} from "../RoadKill";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {RoadKillModel} from "../server/RoadKillModel";
import {RoadKillUtils} from "../utils/RoadKillUtils";
import {RoadKillSymbol} from "../reels/RoadKillSymbol";
import {RoadKillSymbolStates} from "../component/enums/RoadKillEnums";
import {IWinHighLightData} from "../server/RoadKillData";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";
import {RoadKillSound} from "../sound/RoadKillSound";

export class RoadKillBigWinRunner implements SimplePresentation {
    private _mainTl: TimelineLite;

    constructor() {
        //do Nothing
    }

    public shouldRun(): boolean {
        return RoadKill.model.winRatio >= 15 && !RoadKill.model.brokeTheBank;
    }

    public start(flowStateController: SimplePresentationRunnerController): void {
        this._mainTl = new TimelineLite({
                onComplete: () => {
                    RoadKill.bigWinView.playBigWin(flowStateController);
                }
            }
        );
        if (RoadKill.model.gameData.doMassiveWildThisSpin) {
            this._mainTl.add(RoadKill.massiveWinView.playSpecificAnimation("win", false, true));
            this._mainTl.add(RoadKill.massiveWinView.playSpecificAnimation("win_idle", true, false));
        }
        this._mainTl.add(RoadKill.jumpingWildView.hideShowAllSW());
    }
}